import * as Yup from "yup";

export const licenseCategorySchema = Yup.object().shape({
  name: Yup.string().required("Name field cannot be empty"),
});
